/**
 * @flow
 * @relayHash ab03a8d63b1241c06b568c367be1feea
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type UserEdit_viewer$ref = any;
export type queries_UserQueryVariables = {|
  id: string
|};
export type queries_UserQueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: UserEdit_viewer$ref
  |}
|};
export type queries_UserQuery = {|
  variables: queries_UserQueryVariables,
  response: queries_UserQueryResponse,
|};
*/


/*
query queries_UserQuery(
  $id: ID!
) {
  viewer {
    ...UserEdit_viewer_1Bmzm5
    id
  }
}

fragment UserEdit_viewer_1Bmzm5 on Viewer {
  id
  user(id: $id) {
    id
    name
    email
    active
    canDelete
    blocked
    testText
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "queries_UserQuery",
  "id": null,
  "text": "query queries_UserQuery(\n  $id: ID!\n) {\n  viewer {\n    ...UserEdit_viewer_1Bmzm5\n    id\n  }\n}\n\nfragment UserEdit_viewer_1Bmzm5 on Viewer {\n  id\n  user(id: $id) {\n    id\n    name\n    email\n    active\n    canDelete\n    blocked\n    testText\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "queries_UserQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "UserEdit_viewer",
            "args": [
              {
                "kind": "Variable",
                "name": "id",
                "variableName": "id",
                "type": null
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "queries_UserQuery",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          v1,
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "user",
            "storageKey": null,
            "args": [
              {
                "kind": "Variable",
                "name": "id",
                "variableName": "id",
                "type": "ID!"
              }
            ],
            "concreteType": "User",
            "plural": false,
            "selections": [
              v1,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "name",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "email",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "active",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "canDelete",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "blocked",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "testText",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '4688178ca8a11cdef6ea76228c3805d5';
module.exports = node;



// WEBPACK FOOTER //
// src/__generated__/queries_UserQuery.graphql.js